import { type QueryRef, useBackgroundQuery, useReadQuery } from '@apollo/client/react';
import type { GoodsTypesQueryQuery } from '../../../gql/graphql';
import { goodsTypesQuery } from '../graphql/GoodsTypesQuery';

export interface GoodsTypesQueryRefProps {
  goodsTypesQueryRef: QueryRef<GoodsTypesQueryQuery>;
}

export const useGoodsTypesBackgroundQuery = (): QueryRef<GoodsTypesQueryQuery> => {
  const [queryRef] = useBackgroundQuery(goodsTypesQuery, { fetchPolicy: 'cache-first' });

  return queryRef;
};

export const useGoodsTypes = (
  queryRef: QueryRef<GoodsTypesQueryQuery>,
  options?: {
    includeInvalidGoodsTypes?: boolean;
  },
) => {
  const { data, error } = useReadQuery(queryRef);

  return {
    goodsTypes: (data.viewer.goodsTypes.all ?? []).filter(
      c => options?.includeInvalidGoodsTypes || c.isValid,
    ),
    error,
  };
};
